import { eventType, noonReportType } from './enums.js';

export const getEventsFilteredOnEospSops = (events) => {
    return events
        .filter(
            (e) =>
                e &&
                [
                    eventType.eosp,
                    eventType.sosp,
                    eventType.allFast,
                    eventType.allClear,
                    eventType.anchorAweighCargoOps,
                    eventType.wellAnchoredCargoOps,
                    eventType.anchorAweighNoCargo,
                    eventType.wellAnchoredNoCargo,
                    eventType.dryDockingCommenced,
                    eventType.dryDockingCompleted,
                    eventType.dryDockingBerthCommenced,
                    eventType.dryDockingBerthCompleted,
                    eventType.bunkerBargeAlongsideAtBerth,
                    eventType.bunkerBargeCastedOffAtBerth,
                ].includes(e.eventTypeId)
        )
        .sort((a, b) => {
            if (a.eventDate.actualDateTimeUTC !== b.eventDate.actualDateTimeUTC) {
                return new Date(a.eventDate.actualDateTimeUTC) - new Date(b.eventDate.actualDateTimeUTC);
            } else if (a.created !== b.created) {
                return new Date(a.created) - new Date(b.created);
            } else {
                return a.portClusterCallId - b.portClusterCallId;
            }
        });
};

export const getAolTypeFromEvent = (ev) => {
    if (isEospEvent(ev.eventTypeId)) return noonReportType.arrival;
    if (isArrivalEvent(ev.eventTypeId)) return noonReportType.port;
    if (isDepartureEvent(ev.eventTypeId)) return noonReportType.departure;
    if (isSospEvent(ev.eventTypeId)) return noonReportType.sea;
    return noonReportType.sea;
};

export const filterSimpleAolTypeEvents = (evList) => {
    return evList.filter(
        (ev) =>
            ev.eventTypeId === 1 || // eosp
            ev.eventTypeId === 195 || // simpleBerthArrival
            ev.eventTypeId === 196 || // simpleBerthDeparture
            ev.eventTypeId === 3 || // sosp
            ev.eventTypeId === eventType.wellAnchored || // port-level anchoring (for anchoring time calculation)
            ev.eventTypeId === eventType.anchorAweigh // port-level anchor aweigh
    );
};

export const isEospEvent = (eventTypeId) => eventTypeId === eventType.eosp;
export const isSospEvent = (eventTypeId) => eventTypeId === eventType.sosp;
export const isArrivalEvent = (eventTypeId) =>
    eventTypeId === eventType.allFast ||
    eventTypeId === eventType.wellAnchoredCargoOps ||
    eventTypeId === eventType.wellAnchoredNoCargo ||
    eventTypeId === eventType.dryDockingCommenced ||
    eventTypeId === eventType.dryDockingBerthCommenced ||
    eventTypeId === eventType.bunkerBargeAlongsideAtBerth;

export const isDepartureEvent = (eventTypeId) =>
    eventTypeId === eventType.allClear ||
    eventTypeId === eventType.anchorAweighCargoOps ||
    eventTypeId === eventType.anchorAweighNoCargo ||
    eventTypeId === eventType.dryDockingCompleted ||
    eventTypeId === eventType.dryDockingBerthCompleted ||
    eventTypeId === eventType.bunkerBargeCastedOffAtBerth;
